import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import * as OrderActions from "../actions";
import type { IPriceRequestState } from "../types";

export type OrderAction = ActionType<typeof OrderActions>;

const initialPriceRequestState: IPriceRequestState = {
  isStarting: false,
  isFetching: false,
  hasError: false,
  waitingForUpdate: false,
  priceRequest: null!,
  errorStatusCode: 0,
  progress: 0
};

export default function priceRequestReducer(state: IPriceRequestState = initialPriceRequestState, action: OrderAction): IPriceRequestState {
  switch (action.type) {
    case getType(OrderActions.startPriceRequestsStart):
      return { ...state, isStarting: true };

    case getType(OrderActions.startPriceRequestsSuccess):
    case getType(OrderActions.startPriceRequestsFail):
      return { ...state, isStarting: false };

    case getType(OrderActions.fetchPriceRequestStart):
      return { ...initialPriceRequestState, isFetching: true };

    case getType(OrderActions.updateOrderStart):
      return { ...state, isFetching: true, hasError: false, errorStatusCode: 0 };

    case getType(OrderActions.fetchPriceRequestFail):
    case getType(OrderActions.updateOrderFail):
      return { ...state, isFetching: false, hasError: true, errorStatusCode: action.payload.statusCode || 0 };

    case getType(OrderActions.fetchPriceRequestSuccess):
    case getType(OrderActions.updateOrderSuccess):
      return { ...state, isFetching: false, priceRequest: action.payload };

    case getType(OrderActions.fetchPriceRequestProgress):
      return { ...state, progress: action.payload };

    case getType(OrderActions.updatePriceRequestPosition): {
      const { id, update } = action.payload;
      const updatedOrderPositions = state.priceRequest.orderPositions.map((pos) => (pos.id === id ? { ...pos, ...update } : pos));

      // Check if all quantities are the same as the original quantities
      const allQuantitiesSameAsOriginal = updatedOrderPositions.every((pos) => pos.qty === pos.originalQty);

      return {
        ...state,
        waitingForUpdate: !allQuantitiesSameAsOriginal,
        priceRequest: {
          ...state.priceRequest,
          orderPositions: state.priceRequest.orderPositions.map((pos) => (pos.id === id ? { ...pos, ...update } : pos))
        }
      };
    }

    case getType(OrderActions.setWaitingForUpdate):
      return { ...state, waitingForUpdate: action.payload };

    default:
      return state;
  }
}
